import React from 'react'
import { Form, Row, Col, Modal, Button } from 'react-bootstrap'
import * as Yup from 'yup'
import type { FormikErrors, FormikTouched } from 'formik'

interface MediaUpsertFormValues {
  name: string
}

interface MediaUpsertFormProps {
  values: MediaUpsertFormValues
  errors: FormikErrors<MediaUpsertFormValues>
  touched: FormikTouched<MediaUpsertFormValues>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: React.SubmitEventHandler<HTMLFormElement>
  isValid: boolean
  fetching: boolean
  onClickCancel: () => void
  title: string
  submitButtonText: string
}

const _MediaUpsertForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isValid,
  fetching,
  onClickCancel,
  title,
  submitButtonText
}: MediaUpsertFormProps) => (
  <>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Form noValidate onSubmit={handleSubmit}>
      <Modal.Body>
        <Form.Group as={Row} className='mb-3'>
          <Form.Label column className='col-2'>
            名称
          </Form.Label>
          <Col>
            <Form.Control
              type='text'
              name='name'
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              isInvalid={!!(touched.name && errors.name)}
            />
            <Form.Control.Feedback type='invalid'>{errors.name}</Form.Control.Feedback>
          </Col>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClickCancel}>
          キャンセル
        </Button>
        <Button type='submit' disabled={!isValid || fetching}>
          {submitButtonText}
        </Button>
      </Modal.Footer>
    </Form>
  </>
)

export const MediaUpsertForm = Object.assign(_MediaUpsertForm, {
  schema: Yup.object().shape({
    name: Yup.string().required()
  })
})
